import PropTypes from "prop-types";
import React from "react";
import {RequiredAstrix} from "./FormElements";

function InputField(props) {
    const {
        id,
        label,
        required,
        name,
        type,
        fieldLength,
        values,
        handleChange,
        handleBlur,
        classNameWrapper,
        errors,
        touched,
        maxLength,
        placeholder,
    } = props;

    return (
        <div className={`form-group ${classNameWrapper}`}>
            <label htmlFor={id} className={'heading'}>{label} {required && <RequiredAstrix />}</label>
            <input
                name={name}
                type={type}
                placeholder={placeholder}
                className={`form-control ${fieldLength}`}
                value={values[name]}
                onChange={handleChange}
                id={id}
                onBlur={handleBlur}
                autoComplete={'off'}
                maxLength={maxLength}
            />
            {touched[name] && errors[name] && <div className={'invalid'}>{errors[name]}</div>}
        </div>
    )
}

InputField.propTypes = {
    id: PropTypes.string.isRequired,
    label: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    type: PropTypes.string,
    placeholder: PropTypes.string,
    required: PropTypes.bool,
    fieldLength: PropTypes.string,
    values: PropTypes.object,
    handleChange: PropTypes.func,
    handleBlur: PropTypes.func,
    classNameWrapper: PropTypes.string,
    maxLength: PropTypes.number,
}

InputField.defaultProps = {
    required: false,
    fieldLength: 'short',
    type: 'text',
    values: {},
    handleChange: undefined,
    handleBlur: undefined,
    classNameWrapper: '',
    placeholder: '',
}

export default InputField;
